module.exports = __webpack_public_path__ + "img/2.77ead05f.jpg";